export const REGISTRATION_URL = 'http://www.dxxf119.cn/wap/baoming.asp'

export const SIGN_KEY = 'yskey.key'
